"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/yogaSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeSeventeenYogaSectionGeneratedProps = {
    /** Default: "Community" */
    sectionDiv0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Support Network" */
    sectionDiv0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "yoga" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/yoga-img-2.jpg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Mental Wellness" */
    sectionDiv0Div0Div1H20H2Text?: ReactNode;
    sectionDiv0Div0Div1H20H2Visible?: boolean;
    sectionDiv0Div0Div1H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Tracking" */
    sectionDiv0Div0Div1H20Span0SpanText?: ReactNode;
    /** Default: "yoga" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/yoga-img-3.jpg" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Wellness" */
    sectionDiv0Div0Div2H20H2Text?: ReactNode;
    sectionDiv0Div0Div2H20H2Visible?: boolean;
    sectionDiv0Div0Div2H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div2H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Goal Management" */
    sectionDiv0Div0Div2H20Span0SpanText?: ReactNode;
    /** Default: "yoga" */
    sectionDiv0Div0Div2ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/yoga-img-4.jpg" */
    sectionDiv0Div0Div2ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div2ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div2ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Telehealth" */
    sectionDiv0Div0Div3H20H2Text?: ReactNode;
    sectionDiv0Div0Div3H20H2Visible?: boolean;
    sectionDiv0Div0Div3H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div3H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Consultations" */
    sectionDiv0Div0Div3H20Span0SpanText?: ReactNode;
    /** Default: "yoga" */
    sectionDiv0Div0Div3ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/yoga-img-5.jpg" */
    sectionDiv0Div0Div3ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div3ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div3ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div3ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "yoga" */
    sectionDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/yoga-img-1.png" */
    sectionDiv0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "yoga-img" */
    sectionDiv0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/yoga-shadow-1.png" */
    sectionDiv0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "yoga-img" */
    sectionDiv0Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/yoga-circle-1.png" */
    sectionDiv0Div0ImageWithBasePath2ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "yoga" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "1s" */
    sectionImageWithBasePath0ImageDataWowDuration?: string;
    /** Default: "/Templates/Doccure/img/bg/yoga-img.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeSeventeenYogaSectionGenerated: FC<HomeSeventeenYogaSectionGeneratedProps> = ({
    sectionDiv0Div0Div0H20H2Text = "Community",
    sectionDiv0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0H20H2Props,
    sectionDiv0Div0Div0H20Span0SpanText = "Support Network",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "yoga",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/yoga-img-2.jpg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1H20H2Text = "Mental Wellness",
    sectionDiv0Div0Div1H20H2Visible,
    sectionDiv0Div0Div1H20H2Renderer,
    sectionDiv0Div0Div1H20H2Props,
    sectionDiv0Div0Div1H20Span0SpanText = "Tracking",
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt = "yoga",
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/yoga-img-3.jpg",
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div2H20H2Text = "Wellness",
    sectionDiv0Div0Div2H20H2Visible,
    sectionDiv0Div0Div2H20H2Renderer,
    sectionDiv0Div0Div2H20H2Props,
    sectionDiv0Div0Div2H20Span0SpanText = "Goal Management",
    sectionDiv0Div0Div2ImageWithBasePath0ImageAlt = "yoga",
    sectionDiv0Div0Div2ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/yoga-img-4.jpg",
    sectionDiv0Div0Div2ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div2ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div2ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div3H20H2Text = "Telehealth",
    sectionDiv0Div0Div3H20H2Visible,
    sectionDiv0Div0Div3H20H2Renderer,
    sectionDiv0Div0Div3H20H2Props,
    sectionDiv0Div0Div3H20Span0SpanText = "Consultations",
    sectionDiv0Div0Div3ImageWithBasePath0ImageAlt = "yoga",
    sectionDiv0Div0Div3ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/yoga-img-5.jpg",
    sectionDiv0Div0Div3ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div3ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div3ImageWithBasePath0ImageProps,
    sectionDiv0Div0ImageWithBasePath0ImageAlt = "yoga",
    sectionDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/yoga-img-1.png",
    sectionDiv0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0ImageWithBasePath1ImageAlt = "yoga-img",
    sectionDiv0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/yoga-shadow-1.png",
    sectionDiv0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0ImageWithBasePath2ImageAlt = "yoga-img",
    sectionDiv0Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/banner/yoga-circle-1.png",
    sectionDiv0Div0ImageWithBasePath2ImageVisible,
    sectionDiv0Div0ImageWithBasePath2ImageRenderer,
    sectionDiv0Div0ImageWithBasePath2ImageProps,
    sectionImageWithBasePath0ImageAlt = "yoga",
    sectionImageWithBasePath0ImageDataWowDuration = "1s",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/yoga-img.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
}) => {
    return (
        <section className="yoga-section-seventeen section pb-0">
            <div className="container">
                <div className="yoga-details">
                    {renderNode(sectionDiv0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0ImageWithBasePath0ImageAlt} className="img-fluid yoga-img-1 d-none d-lg-block" {...(sectionDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                    <div className="yoga-item item-1">
                        {renderNode(sectionDiv0Div0Div0H20H2Visible, sectionDiv0Div0Div0H20H2Renderer, (
                            <h2 className="title" {...(sectionDiv0Div0Div0H20H2Props ?? {})}>
                                {sectionDiv0Div0Div0H20H2Text}
                                <span>{sectionDiv0Div0Div0H20Span0SpanText}</span>
                            </h2>
                        ))}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-one img-fluid" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="yoga-item item-2">
                        {renderNode(sectionDiv0Div0Div1H20H2Visible, sectionDiv0Div0Div1H20H2Renderer, (
                            <h2 className="title" {...(sectionDiv0Div0Div1H20H2Props ?? {})}>
                                {sectionDiv0Div0Div1H20H2Text}
                                <span>{sectionDiv0Div0Div1H20Span0SpanText}</span>
                            </h2>
                        ))}
                        {renderNode(sectionDiv0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath0ImageAlt} className="img-one img-fluid" {...(sectionDiv0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="yoga-item item-3">
                        {renderNode(sectionDiv0Div0Div2H20H2Visible, sectionDiv0Div0Div2H20H2Renderer, (
                            <h2 className="title" {...(sectionDiv0Div0Div2H20H2Props ?? {})}>
                                {sectionDiv0Div0Div2H20H2Text}
                                <span>{sectionDiv0Div0Div2H20Span0SpanText}</span>
                            </h2>
                        ))}
                        {renderNode(sectionDiv0Div0Div2ImageWithBasePath0ImageVisible, sectionDiv0Div0Div2ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div2ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div2ImageWithBasePath0ImageAlt} className="img-one img-fluid" {...(sectionDiv0Div0Div2ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="yoga-item item-4">
                        {renderNode(sectionDiv0Div0Div3H20H2Visible, sectionDiv0Div0Div3H20H2Renderer, (
                            <h2 className="title" {...(sectionDiv0Div0Div3H20H2Props ?? {})}>
                                {sectionDiv0Div0Div3H20H2Text}
                                <span>{sectionDiv0Div0Div3H20Span0SpanText}</span>
                            </h2>
                        ))}
                        {renderNode(sectionDiv0Div0Div3ImageWithBasePath0ImageVisible, sectionDiv0Div0Div3ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div3ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div3ImageWithBasePath0ImageAlt} className="img-one img-fluid" {...(sectionDiv0Div0Div3ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0ImageWithBasePath1ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0ImageWithBasePath1ImageAlt} className="yoga-shadow d-none d-lg-block" {...(sectionDiv0Div0ImageWithBasePath1ImageProps ?? {})} />
                    ))}
                    {renderNode(sectionDiv0Div0ImageWithBasePath2ImageVisible, sectionDiv0Div0ImageWithBasePath2ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath2ImageSrc} alt={sectionDiv0Div0ImageWithBasePath2ImageAlt} className="yoga-shadow-two d-none d-lg-block" {...(sectionDiv0Div0ImageWithBasePath2ImageProps ?? {})} />
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid yoga-img-2 d-none d-lg-block wow zoomIn" data-wow-duration={sectionImageWithBasePath0ImageDataWowDuration} {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSeventeenYogaSectionGenerated;
